import { Grid, TextField, MenuItem, FormControlLabel, Checkbox, Typography, Box, Chip } from '@mui/material';
import React from 'react';

const VistaNotificacion = (props) => {
    const { item } = props;

    const formatearFechaHora = (fechaHora) => {
        if (!fechaHora) return '';
        try {
            return new Date(fechaHora).toLocaleString('es-MX', {
                dateStyle: 'full',
                timeStyle: 'short'
            });
        } catch (error) {
            return fechaHora;
        }
    };

    const formatearFechaHoraCompacto = (fechaHora) => {
        if (!fechaHora) return '';
        try {
            return new Date(fechaHora).toLocaleString('es-MX', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (error) {
            return fechaHora;
        }
    };

    const obtenerDiaMes = (fecha) => {
        if (!fecha) return { dia: '', mes: '' };
        const f = new Date(fecha);
        const nombresMeses = [
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre'
        ];
        return {
            dia: f.getDate(),
            mes: nombresMeses[f.getMonth()]
        };
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField fullWidth label="Título" value={item?.Titulo || ''} InputProps={{ readOnly: true }} variant="filled" />
            </Grid>

            {item?.slide != 1 && (
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Descripción"
                        value={item?.Descripcion || ''}
                        InputProps={{ readOnly: true }}
                        variant="filled"
                    />
                </Grid>
            )}

            {item?.slide == 1 && (
                <Grid item xs={12}>
                    <Box
                        sx={{
                            border: '1px dashed #2196f3',
                            borderRadius: 1,
                            p: 2,
                            backgroundColor: '#e3f2fd',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}
                    >
                        <Typography variant="body2" color="black">
                            ℹ️ Esta notificación se muestra como slide (la descripción no se visualiza en el slide)
                        </Typography>
                    </Box>
                </Grid>
            )}

            {/* Mostrar fechas solo si NO es ANUAL */}
            {item?.periodo !== 'UNA_VEZ' && item?.periodo !== 'ANUAL' && (
                <>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Fecha y hora de inicio"
                            value={formatearFechaHoraCompacto(item?.fecha_inicio)}
                            InputProps={{ readOnly: true }}
                            variant="filled"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Fecha y hora de fin"
                            value={formatearFechaHoraCompacto(item?.fecha_fin)}
                            InputProps={{ readOnly: true }}
                            variant="filled"
                        />
                    </Grid>
                </>
            )}

            <Grid item xs={6}>
                <TextField
                    fullWidth
                    label="Tipo de usuario"
                    value={item?.TipoUsuario_nombre || ''}
                    InputProps={{ readOnly: true }}
                    variant="filled"
                />
            </Grid>

            <Grid item xs={6}>
                <TextField fullWidth label="Sede" value={item?.sede_nombre || ''} InputProps={{ readOnly: true }} variant="filled" />
            </Grid>

            <Grid item xs={6}>
                <Box>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        Mostrar en slide
                    </Typography>
                    <FormControlLabel
                        control={<Checkbox checked={item?.slide == 1} disabled color="secondary" />}
                        label={item?.slide == 1 ? 'Sí' : 'No'}
                    />
                </Box>
            </Grid>

            <Grid item xs={6}>
                <TextField fullWidth label="Estatus" value={item?.estatus_texto || ''} InputProps={{ readOnly: true }} variant="filled" />
            </Grid>

            {item?.slide == 1 && item?.imagenUrl && (
                <Grid item xs={12}>
                    <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 1, p: 2, backgroundColor: '#f5f5f5' }}>
                        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                            Imagen del slide
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                mt: 2,
                                backgroundColor: '#fff',
                                borderRadius: 1,
                                p: 2
                            }}
                        >
                            <img
                                src={item.imagenUrl}
                                alt={item.Titulo}
                                style={{
                                    maxWidth: '100%',
                                    maxHeight: '400px',
                                    objectFit: 'contain',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                                }}
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />
                            <Typography variant="body2" color="error" sx={{ display: 'none', textAlign: 'center' }}>
                                Error al cargar la imagen
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            )}

            {item?.slide == 1 && !item?.imagenUrl && (
                <Grid item xs={12}>
                    <Box sx={{ border: '1px dashed #ffb74d', borderRadius: 1, p: 2, backgroundColor: '#fff3e0' }}>
                        <Typography variant="body2" color="textSecondary" textAlign="center">
                            ⚠️ El slide está activo pero no tiene imagen adjunta
                        </Typography>
                    </Box>
                </Grid>
            )}

            {/* SECCIÓN DE PERIODICIDAD */}
            {item?.periodo && (
                <>
                    <Grid item xs={12}>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                mt: 2,
                                mb: 1,
                                fontWeight: 600,
                                color: (theme) => (theme.palette.mode === 'dark' ? '#ffffff' : '#000000'),
                                opacity: '1 !important'
                            }}
                        >
                            📅 Configuración de Periodicidad
                        </Typography>
                    </Grid>

                    <Grid item xs={item?.periodo === 'UNA_VEZ' || item?.periodo === 'ANUAL' ? 12 : 6}>
                        <TextField
                            fullWidth
                            label="Periodo"
                            value={
                                item?.periodo === 'UNA_VEZ'
                                    ? 'Una vez'
                                    : item?.periodo === 'DIARIO'
                                    ? 'Diario'
                                    : item?.periodo === 'SEMANAL'
                                    ? 'Semanal'
                                    : item?.periodo === 'ANUAL'
                                    ? 'Anual (se repite cada año)'
                                    : item?.periodo || ''
                            }
                            InputProps={{ readOnly: true }}
                            variant="filled"
                        />
                    </Grid>

                    {item?.periodo === 'SEMANAL' && item?.Dia_Semana && (
                        <Grid item xs={6}>
                            <TextField
                                fullWidth
                                label="Día de la semana"
                                value={item?.Dia_Semana || ''}
                                InputProps={{ readOnly: true }}
                                variant="filled"
                            />
                        </Grid>
                    )}

                    {/* MOSTRAR INFORMACIÓN DE RECURRENCIA ANUAL */}
                    {item?.periodo === 'ANUAL' && item?.fecha_inicio && (
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    border: '2px solid #9c27b0',
                                    borderRadius: 2,
                                    p: 2,
                                    backgroundColor: '#f3e5f5',
                                    mt: 1
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    gutterBottom
                                    sx={{
                                        fontWeight: 600,
                                        color: '#000000'
                                    }}
                                >
                                    🔄 Notificación Anual Recurrente
                                </Typography>
                                <Typography variant="body1" color="text.primary" sx={{ mt: 1, fontWeight: 500 }}>
                                    Esta notificación se mostrará cada{' '}
                                    <strong>
                                        {obtenerDiaMes(item.fecha_inicio).dia} de {obtenerDiaMes(item.fecha_inicio).mes}
                                    </strong>{' '}
                                </Typography>

                                <Box
                                    sx={{
                                        mt: 2,
                                        display: 'flex',
                                        gap: 1,
                                        flexWrap: 'wrap',
                                        '& .MuiChip-label': {
                                            color: '#000000'
                                        }
                                    }}
                                >
                                    <Chip
                                        label={`📅 Día ${obtenerDiaMes(item.fecha_inicio).dia}`}
                                        color="secondary"
                                        variant="outlined"
                                        size="small"
                                    />
                                    <Chip
                                        label={`📆 ${obtenerDiaMes(item.fecha_inicio).mes}`}
                                        color="secondary"
                                        variant="outlined"
                                        size="small"
                                    />
                                    <Chip label="♾️ Cada año" color="secondary" variant="outlined" size="small" />
                                </Box>
                            </Box>
                        </Grid>
                    )}

                    {/* MOSTRAR FECHA Y HORA SI ES UNA VEZ */}
                    {item?.periodo === 'UNA_VEZ' && item?.fecha_inicio && (
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    border: '2px solid #2196f3',
                                    borderRadius: 2,
                                    p: 2,
                                    backgroundColor: '#e3f2fd',
                                    mt: 1
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    gutterBottom
                                    sx={{
                                        fontWeight: 600,
                                        color: '#000000'
                                    }}
                                >
                                    🕐 Fecha y hora programada
                                </Typography>
                                <Typography variant="h6" color="text.primary" sx={{ mt: 1 }}>
                                    {formatearFechaHora(item.fecha_inicio)}
                                </Typography>
                                <Box
                                    sx={{
                                        mt: 2,
                                        display: 'flex',
                                        gap: 1,
                                        flexWrap: 'wrap',
                                        '& .MuiChip-label': {
                                            color: '#000000'
                                        }
                                    }}
                                >
                                    <Chip
                                        label={`📅 ${new Date(item.fecha_inicio).toLocaleDateString('es-MX', {
                                            day: '2-digit',
                                            month: 'long',
                                            year: 'numeric'
                                        })}`}
                                        color="primary"
                                        variant="outlined"
                                        size="small"
                                    />
                                    <Chip
                                        label={`🕐 ${new Date(item.fecha_inicio).toLocaleTimeString('es-MX', {
                                            hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                        })}`}
                                        color="primary"
                                        variant="outlined"
                                        size="small"
                                    />
                                </Box>
                            </Box>
                        </Grid>
                    )}
                </>
            )}
        </Grid>
    );
};

export default VistaNotificacion;
